import {
  componentNameConstants,
  dlElementConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";
import { TabItem } from "./types";
import { dataLayer } from "@repo/analytics/data-layer-utils";

export const trackTabClick = (selectedTab: TabItem, pageName: boolean) => {
  try {
    const cta_text = selectedTab.label.trim();
    const destination_url = selectedTab.redirectLink;

    const clevertapObj = {
      EP_PAGE_NAME: pageName
        ? dlElementConstants.MTF_CLP
        : dlElementConstants.TRADING,
      EP_JOURNEY_NAME: pageName
        ? dlElementConstants.MTF_CLP_EP
        : dlElementConstants.TRADING_MALL_CLP_EP,
      EP_TAB: cta_text.toUpperCase(),
    };

    const dataLayerObj = {
      event: dlEventConstants.CLICK,
      event_type: dlEventConstants.TAB_CLICK,
      element: pageName
        ? dlElementConstants.MTF_TAB_CLICK
        : dlElementConstants.TRADING_TAB_CLICK,
      component: pageName
        ? componentNameConstants.MTF
        : componentNameConstants.TRADING,
      section_title: cta_text,
      cta_text: cta_text,
      destination_url: destination_url,
    };

    dataLayer("", dataLayerObj, clevertapObj);
  } catch (error) {
    console.error("Data layer tracking error:", error);
  }
};

export const detectPageType = (): boolean => {
  if (typeof document !== "undefined") {
    return document.title.toLowerCase().includes("mtf");
  }
  return false;
};
